import {ChartModel} from '@xh/hoist/cmp/chart';
import {HoistModel, managed} from '@xh/hoist/core';
import {runInAction} from '@xh/hoist/mobx';

export class RatesWidgetModel extends HoistModel {
    @managed chartModel = new ChartModel({highchartsConfig: this.createChartModel()});

    override onLinked() {
        super.onLinked();

        this.updateChartData();
    }

    private updateChartData() {
        // https://financialmodelingprep.com/stable/treasury-rates?from=2026-03-13&to=2026-03-16
        const data = [
            {tenor: '1M', rate: 0.0375},
            {tenor: '2M', rate: 0.0372},
            {tenor: '3M', rate: 0.0372},
            {tenor: '6M', rate: 0.0372},
            {tenor: '1Y', rate: 0.0364},
            {tenor: '2Y', rate: 0.0368},
            {tenor: '3Y', rate: 0.0369},
            {tenor: '5Y', rate: 0.038},
            {tenor: '7Y', rate: 0.04},
            {tenor: '10Y', rate: 0.0423},
            {tenor: '20Y', rate: 0.0483},
            {tenor: '30Y', rate: 0.0486}
        ];

        let rateSeries = {
            name: 'Rate',
            data: data.map(d => d.rate * 100)
        };

        runInAction(() => {
            this.chartModel.updateHighchartsConfig({
                xAxis: {categories: data.map(d => d.tenor)}
            });
            this.chartModel.setSeries([rateSeries]);
        });
    }

    private createChartModel() {
        return {
            chart: {type: 'column', animation: false},
            xAxis: {},
            yAxis: {
                title: {text: null}
            },
            legend: {enabled: false},
            plotOptions: {
                series: {animation: false},
                column: {
                    borderWidth: 0,
                    dataLabels: {enabled: false, format: '{point.y:.2f}%'}
                }
            },
            tooltip: {
                shared: true,
                headerFormat: '<b>{point.key}</b><br/>',
                pointFormat: '{point.y:.2f}%<br/>'
            }
        };
    }
}
